export const tr = {
    dayBudgetMode: 'Gösterim modu',
    perDay: 'günde'
};
